module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "placeholder.a5bf41de.svg";